mutation UpdateTrainingAssignment(
  $assignmentId: ID!
  $exempt: Boolean
  $exemptReason: String
  $dueOn: ISO8601Date
) {
  updateTrainingAssignment(
    input: {
      assignmentId: $assignmentId
      exempt: $exempt
      exemptReason: $exemptReason
      dueOn: $dueOn
    }
  ) {
    assignment {
      id
      dueOn
      exemptedAt
      exemptReason
    }
  }
}
